module.exports = __webpack_public_path__ + "static/media/fuel-charging.1942f741.svg";